<template>
  <div class="column-key-map-wrapper">
    <draggable v-model="localValue" draggable=".logic-row-wrapper">
      <div v-for="(rulesRow, i) in localValue" class="logic-row-wrapper">
        <div
            class="logic-row-inner-wrapper"
            :style="localValue[i].disabled ? 'filter:grayscale(100%) brightness(0.9) opacity(.5);' : 'filter:grayscale(0%) brightness(1) opacity(1);'"
        >
          <div class="flex items-center justify-between mb-4">
            <select class="form-control w-180p mr-2" v-model="rulesRow.is_CustomQuestion">
              <option value="1">Custom Question</option>
              <option value="0">Display Field</option>
            </select>

            <input
                type="text"
                placeholder="QuestionId"
                class="form-control mr-2"
                data-form-type="other"
                v-model="rulesRow.QuestionId"
                :data-w-input="`${dataWInput}-${i}-cq-id`"
            />

            <input
                type="text"
                placeholder="Question"
                class="form-control mr-2"
                data-form-type="other"
                v-model="rulesRow.Question"
                :data-w-input="`${dataWInput}-${i}-cq`"
            />

            <input
                type="text"
                placeholder="Answer"
                class="form-control"
                data-form-type="other"
                v-model="rulesRow.Answer"
                :data-w-input="`${dataWInput}-${i}-cq-answer`"
            />
          </div>

          <repeatable-input
              v-model="localValue[i].rules"
              :striped="true"
              :proto="ruleRow"
              :add-icon-to-btm="true"
              remove-icon="fa-times"
          >
            <template v-slot:default="{ row, rowIndex }">
              <div class="flex flex-wrap my-2">
                <div class="w-full flex items-center">
                  <div class="text-right shrink-0 px-1" style="width: 38px">{{ rowIndex ? 'And' : 'If' }}</div>

                  <select
                      v-model="row.lead_column"
                      :data-w-input="`${dataWInput}-${i}-rules-${rowIndex}-column`"
                      class="form-control mr-2 w-full"
                  >
                    <option value disabled>lead table column</option>
                    <option v-for="column in leadColumnOptions" :key="column" :value="column" :hidden="column.startsWith('scn.')">
                      {{ column }}
                    </option>
                  </select>

                  <select
                      class="form-control mr-2"
                      v-model="row.operator"
                      :data-w-input="`${dataWInput}-${i}-rules-${rowIndex}-operator`"
                  >
                    <option value="is">is</option>
                    <option value="isNot">is not</option>
                    <option value="greaterThan">is greater than</option>
                    <option value="lessThan">is less than</option>
                    <option value="contains">contains</option>
                    <option value="excludes">excludes</option>
                    <option value="startsWith">starts with</option>
                    <option value="endsWith">ends with</option>
                  </select>

                  <div class="flex items-center justify-between">
                    <select
                        v-model="row.scope"
                        :data-w-input="`${dataWInput}-${i}-rules-${rowIndex}-scope`"
                        class="form-control w-full !min-w-[100px]"
                    >
                      <option value="all">all</option>
                      <option value="any">any</option>
                    </select>
                  </div>
                </div>

                <textarea
                    :data-w-input="`${dataWInput}-${i}-rules-${rowIndex}-lead-value`"
                    type="text"
                    class="form-control mt-2"
                    style="margin-left: 38px"
                    v-model="row.lead_value"
                    placeholder="comma separated"
                ></textarea>
              </div>
            </template>
          </repeatable-input>
        </div>

        <logic-field-controls
            :value.sync="localValue[i]"
            :index="i"
            :field-name="'custom_questions'"
        ></logic-field-controls>
      </div>

      <button
          slot="footer"
          class="btn btn-outline-primary hover:bg-green-500 hover:text-white"
          @click.prevent="addRulesRow"
      >Add New Rule Set</button>
    </draggable>
  </div>
</template>

<script>
import {leadColumns} from "../../lib/helpers";
import {add as addCustomQuestion} from "../../lib/CustomQuestion";
import draggable from 'vuedraggable';
import LogicFieldControls from '../form-ui/LogicFieldControls';

export default {
  components: {
    LogicFieldControls,
    draggable,
  },
  props: {
    leadTableColumns: {type: Array, required: true},
    value: {type: Array, required: true},
    confirmBox: {type: Boolean, default: false},
    dataWInput: {type: String, default: ''},
  },
  data() {
    return {
      newRulesRow: {
        is_CustomQuestion: '1',
        QuestionId: '',
        Question: '',
        Answer: '',
        disabled: false,
        rules: [],
      },
      ruleRow: [
        {
          lead_column: '',
          operator: 'is',
          scope: 'all',
          lead_value: '',
        }
      ],
      disableConfirmBox: false,
      customQuestionID: '',
    };
  },
  computed: {
    localValue: {
      get() {
        let local = [];

        if (this.value.length) {
          this.value.forEach(row => {
            if (typeof row.rules === 'undefined') {
              row.rules = [
                {
                  lead_column: row.lead_column,
                  operator: row.operator,
                  scope: row.scope,
                  lead_value: row.lead_value,
                }
              ];

              delete row.lead_column;
              delete row.operator;
              delete row.scope;
              delete row.lead_value;
            }

            if (row.rules.length) addCustomQuestion(this, row.rules, 'lead_column', 'leadColumnOptions');

            if (typeof row.disabled === 'undefined') row.disabled = false;

            if (typeof row.is_CustomQuestion === 'undefined') row.is_CustomQuestion = "1";

            local.push(row);
          });
        }

        return local;
      },
      set(value) {
        this.$dispatch("input", value);
      }
    },
    leadColumnOptions() {
      return leadColumns(this.leadTableColumns);
    },
  },
  methods: {
    removeRulesRow(index) {
      this.localValue.splice(index, 1);
      this.$dispatch("input", this.localValue);
    },
    disableRulesRow(index) {
      this.localValue[index].disabled = !this.localValue[index].disabled
      this.$dispatch("input", this.localValue)
    },
    addRulesRow() {
      let temp = JSON.parse(JSON.stringify(this.localValue));

      temp.push(this.newRulesRow);

      this.$dispatch("input", temp);
    }
  }
}
</script>

<style lang="scss" scoped>
.logic-row-wrapper {
  border: 1px solid rgba(black, .1);
  border-radius: .25rem;
  padding: .5rem;
  background: rgba(black, .05);
  margin-bottom: .5rem;
  position: relative;
}

.logic-row-inner-wrapper {
  transition: filter .25s ease-out;
}

.logic-row-wrapper, .logic-row {
  width: 97%;

  & > * > * {
    margin: 5px;
  }
}

label {
  font-size: .8rem;
}
</style>